import React, { useEffect } from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DropdownMultiselect from "react-multiselect-dropdown-bootstrap";
import { MultiSelect } from "react-multi-select-component";
import {
  getReport,
  getTransactionReportSearchData,
} from "./../../stores/services/report.service";
import moment from "moment";
import { BsTable } from "react-icons/bs";
import html2pdf from "html2pdf.js";
import { txnDropDown, getReuiredFieldForDropDown } from "./fields";
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";
import ReportHeader from "./report-header";
import {
  exportToTxt,
  exportToTxtNCCPL,
  generateExcel,
  numberWithCommas,
} from "../../utils/customFunction";
import { getAmc } from "../../stores/services/amc.service";
import { getFundByAmc } from "../../stores/services/funds.service";
import { useSelector } from "react-redux";
import Select from "react-select";
import ReportTemplates from "../../components/ReportTemplate/ReportTemplate";
import DividendCard from "../dividend/AnnouncementListing";
import TransactionTransferTable from "./transaction-report/transferofunits-report";
import TransactionDefaultTable from "./transaction-report/defualt-report";

const NCCPL_COLUMN_ORDER = [
  { label: "Transfer Date", value: "created_at" },
  { label: "Transaction ID Name", value: "unitholder_name" },
  { label: "S No", value: "" },
  { label: "Settlement", value: "settlement_date" },
  { label: "IN/OUT", value: "" },
  { label: "Inventory Date", value: "settlement_date" },
  { label: "PRU/RDU", value: "" },
  { label: "FUND ID", value: "fund_code" },
  { label: "AMC Code", value: "amc_code" },
  { label: "UIN/NTN", value: "" },
  { label: "Account No", value: "folio_no" },
  { label: "Units IN/OUT", value: "units" },
  { label: "NAV Price", value: "nav" },
  { label: "GAIN/LOSS", value: "" },
  { label: "CGT AMOUNT", value: "tax_cgt" },
  { label: "UNIT Balance After", value: "total_holding" },
  { label: "Dividend Gain Info", value: "dividend_rate" },
  { label: "Remarks", value: "" },
];

const TransactionReportScreen = (props: any) => {
  const contentRef = React.useRef(null);
  const history = useHistory();
  const distName: any = history.location?.state;

  const transaction_Status = [
    {
      value: "CREATED",
      label: "Created",
    },
    {
      value: "COMPLETED",
      label: "Completed",
    },
    {
      value: "REJECTED",
      label: "Rejected",
    },
  ];
  const ColumnHeading = [
    {
      label: "TXN ID",
      value: "TXN ID",
    },
    {
      label: "AMC",
      value: "AMC",
    },
    {
      label: "Creation Date",
      value: "Creation Date",
    },
    {
      label: "folio no",
      value: "folio no",
    },
    {
      label: "fund code",
      value: "fund code",
    },
    {
      label: "unitholder",
      value: "unitholder",
    },
    {
      label: "Sale Date",
      value: "Sale Date",
    },
    {
      label: "Fund Name",
      value: "Fund Name",
    },
    {
      label: "Fund A/C Title",
      value: "Fund A/C Title",
    },
    {
      label: "Fund A/C No.",
      value: "Fund A/C No.",
    },
    {
      label: "Nav",
      value: "Nav",
    },
    {
      label: "Offer Price",
      value: "Offer Price",
    },
    {
      label: "Discount on Load",
      value: "Discount on Load",
    },
    {
      label: "Load Per Unit",
      value: "Load Per Unit",
    },
    {
      label: "Applicable Offer Price",
      value: "Applicable Offer Price",
    },
    {
      label: "Drawer bank",
      value: "Drawer bank",
    },
    {
      label: "Drawer IBAN",
      value: "Drawer IBAN",
    },
    {
      label: "Received Amount",
      value: "Received Amount",
    },
    {
      label: "Sale Load",
      value: "Sale Load",
    },
    {
      label: "Net Sale amount",
      value: "Net Sale amount",
    },
    {
      label: "Units Sold",
      value: "Units Sold",
    },
    {
      label: "Current Holding",
      value: "Current Holding",
    },
    {
      label: "Oustanding Units",
      value: "Oustanding Units",
    },
    {
      label: "Created By",
      value: "Created By",
    },
  ];

  const NCCPLArr = [
    { label: "Sale of Unit", value: "saleofunit" },
    { label: "Redemption of Units", value: "redemptionofunits" },
    { label: "Conversion In", value: "conversionin" },
    { label: "Conversion Out", value: "conversionout" },
  ];

  const [ColumnArr, setColumnArr] = useState(() => ColumnHeading);
  const [selectedValues, setSelectedValues] = useState<any>({
    heading: "",
    sub_heading: "",
    columns: ColumnHeading?.map?.((col) => col?.value),
    balance: [],
  });
  const [fontSizeVal, setFontSizeVal] = useState<any>(18);
  const [paperSizeVal, setPaperSizeVal] = useState("A4");
  const [layoutVal, setLayoutVal] = useState("Landscape");
  const [marginPDF, setMarginPDF] = useState("1cm");
  const [scalePDF, setScalePDF] = useState(0.5);
  const [screenSizePerPdf, setScreenSizePerPdf] = useState();
  const [dimensionOfPages, setDimensionOfPages] = useState<any>();
  const [itemsPerPage, setItemsPerPage] = useState<any>(10);
  const [itemsToShow, setItemsToShow] = useState(10);
  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const pdfExportComponent = React.useRef<PDFExport>(null);
  const [fund_code, setFund_code] = useState(
    JSON.parse(sessionStorage.getItem("fund_code") || "[]"),
  );
  const [loading, setLoading] = useState(false);
  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const amc_name = sessionStorage.getItem("amc_name") || "";
  let date = new Date();
  const [reportTxn, setReportTxn] = useState<any>([]);
  const [allAmc, setAllAmc] = useState<any>([]);
  const [Amc, setAmc] = useState("");
  const [fund, setFund] = useState("");
  const [fields, setFields] = useState({
    amc_code: amc_code,
    fund_code: "",
    from_date: moment(date).format("YYYY-MM-DD"),
    to_date: moment(date).format("YYYY-MM-DD"),
    txn_type: "",
    status: "",
  });

  const [from_date, setFromDate] = useState("");
  const [to_date, setToDate] = useState("");
  const [txn_type, setTxnType] = useState("");
  const [status, setStatus] = useState("");
  const [resAmc, setResAmc] = useState("");
  const [resFund, setResFund] = useState("");

  const [totalNetAmount, setTotalNetAmount] = useState("");
  const [totalGrossAmount, setTotalGrossAmount] = useState("");
  const [totalSaleLoad, setTotalSaleLoad] = useState("");
  const [totalRedemptionLoad, setTotalRedemptionLoad] = useState("");
  const [totalCGT, setTotalCGT] = useState("");
  const [totalUnits, setTotalUnits] = useState("");
  const [totalCurrentHolding, setTotalCurrentHolding] = useState("");
  const [totalZakatAmount, setTotalZakatAmount] = useState("");
  const [totalWHT_II, setTotalWH_IT] = useState("");
  const [totalWHT_SST, setTotalWH_SST] = useState("");
  const [totalTax_SST, setTotalTax_SST] = useState("");
  const [totalTotalAmount, setTotalAmount] = useState("");

  const [totalNetRightShareVolume, setNetRightShareVolume] = useState("");
  const [totalTaxITRightShareAmount, setTotalTaxITRightShareAmount] =
    useState("");
  const [totalRightShareGrossVolume, setTotalRightShareGrossVolume] =
    useState("");
  const [totalTotatNetBonusVolume, setTotalNetBonusVolume] = useState("");
  const [totalTotalTaxItBonusAmount, setTotalTaxItBonusAmount] = useState("");

  // const [dropdownList, setDropdownList] = useState<any>(txnDropDown);
  const [dropdownList, setDropdownList] = useState<any>([]);

  const formatData = (val) => {
    let words = val.split("_");
    return `${words[0]} ${words[1] ? words[1] : ""}`;
  };

  useEffect(() => {
    if (distName) {
      setFields({
        ...fields,
        txn_type:
          distName === "nccpl"
            ? `saleofunit,redemptionofunits,conversionout,conversionin`
            : distName,
        status: distName === "nccpl" ? "COMPLETED" : "",
      });
      let fieldData = getReuiredFieldForDropDown(distName);
      const finalFieldData =
        distName === "nccpl"
          ? NCCPL_COLUMN_ORDER.filter((col) => col.label !== "NCCPL_EMPTY_COL")
          : fieldData;
      setHeaderCoumns(finalFieldData);
      setColumnArr(finalFieldData);
      setSelectedValues({
        ...selectedValues,
        columns: finalFieldData?.map((item) => item?.label),
      });
    } else {
      setFields({
        ...fields,
        txn_type: "",
      });
    }
  }, [distName]);

  React.useEffect(() => {
    if (sessionStorage.getItem("fund_code")) {
      setFund_code(JSON.parse(sessionStorage.getItem("fund_code") || "[]"));
    } else {
      setFund_code(undefined);
    }
  }, []);

  React.useEffect(() => {
    const handleStorageChange = () => {
      const fundCode = sessionStorage.getItem("fund_code");
      setFund_code(fundCode ? JSON.parse(fundCode) : undefined);
    };

    handleStorageChange();

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const getAllAmcFunds = async () => {
    try {
      allFunds.length = 0;
      setAllFunds(allFunds);
      const response = await getFundByAmc(
        email,
        amc_code,
        fund_code?.length > 0 ? fund_code : "",
      );
      setAllFunds(response.data.data);
    } catch (err: any) {
      if (err.response !== undefined) {
        toast.error(err.response.data.message);
      } else {
        toast.error("Request Failed!");
      }
    }
  };

  // React.useEffect(() => {
  //   getAllAmcFunds();
  // }, []);

  React.useEffect(() => {
    getAllAmcFunds();
  }, [fund_code]);

  const [allFunds, setAllFunds] = useState<any>([]);
  // let [allDropdownColumns, setAllDropdownColumns] = useState<any>(txnDropDown);
  let [allDropdownColumns, setAllDropdownColumns] = useState<any>([]);
  let [headerColumns, setHeaderCoumns] = useState<any>([]);
  const [fundLoading, setFundLoading] = useState<boolean>(false);
  const [isSearchTrue, setIsSearchTrue] = useState(false);
  const [txnTypesMulti, setTxnTypesMulti] = useState<any>(NCCPLArr);

  // let txnTypes = JSON.parse(sessionStorage.getItem('txnType') || '');
  let txnTypes = useSelector((state: any) => state.txnTypes);
  const CapTxnType = (type: any) => {
    let i, txType;
    for (i = 0; i < txnTypes.length; i++) {
      if (txnTypes[i].api_name === type) {
        txType = txnTypes[i].dis_name;
        break;
      }
    }

    return txType;
  };

  // const renderFundsDropDown = () => {
  //   return allFunds.map((item: any, index: number) => {
  //     return (
  //       <option key={index} value={item.symbol_code}>
  //         {item.fund_name} - {item.symbol_code}
  //       </option>
  //     );
  //   });
  // };

  const renderFundsDropDown = () => {
    return allFunds?.map((item: any, index: number) => {
      return {
        value: item.symbol_code,
        label: `${item.fund_name} - ${item.symbol_code}`,
      };
    });
  };

  // const renderTxnTypeDropdown = () => {
  //   return txnTypes.map((item: any, index: number) => {
  //     return (
  //       <option key={index} value={item.api_name}>
  //         {item.dis_name}
  //       </option>
  //     );
  //   });
  // };

  const renderTxnTypeDropdown = () => {
    return (
      txnTypes?.length > 0 &&
      txnTypes?.map((item: any, index: number) => {
        return {
          value: item?.api_name,
          label: item?.dis_name,
        };
      })
    );
  };

  const [excelData, setExcelData] = useState([
    {
      TXN_ID: "",
      AMC: "",
      Creation_Date: "",
      folio_no: "",
      fund_code: "",
      unitholder: "",
      Sale_Date: "",
      Fund_Name: "",
      Fund_AC_Title: "",
      Fund_AC_No: "",
      Offer_Price: "",
      Discount_on_Load: "",
      Load_Per_Unit: "",
      Applicable_Offer_Price: "",
      Drawer_bank: "",
      Drawer_IBAN: "",
      Received_Amount: "",
      Sale_Load: "",
      Net_Sale_amount: "",
      Units_Sold: "",
      Current_Holding: "",
      Outstanding_Units: "",
      Created_By: "",
    },
  ]);

  const getNCCPCode: any = () => {
    const ValueIs = allFunds?.find(
      (item) => item?.symbol_code === fields["fund_code"],
    )?.nccpl_code;
    return ValueIs ? ValueIs : "";
  };

  const renderDropdownValues = (index = 0, selectedCol, transaction) => {
    const InArr = ["saleofunit", "conversionin"];
    let res = transaction[selectedCol.value];

    if (selectedCol?.label?.includes("S No")) {
      res = index;
    } else if (selectedCol?.label?.includes("IN/OUT")) {
      res = InArr?.includes(transaction?.txnr_type) ? "IN" : "OUT";
    } else if (selectedCol?.label?.includes("PRU/RDU")) {
      res = InArr?.includes(transaction?.txnr_type) ? "PRU" : "RDU";
    } else if (selectedCol?.label?.includes("UIN/NTN")) {
      res =
        transaction?.ntn ||
        transaction?.cnic ||
        transaction?.unithodlerCNIC ||
        transaction?.unithodlerNTN ||
        "";
    } else if (
      selectedCol?.label?.includes("FUND CODE") &&
      distName === "nccpl"
    ) {
      res = getNCCPCode();
    } else if (selectedCol?.label?.includes("Account No")) {
      res = transaction?.folio_no?.replaceAll("DL-", "");
    } else if (selectedCol?.label?.includes("UNIT Balance After")) {
      res =
        transaction?.txnr_type === "conversionout" ||
        transaction?.txnr_type === "redemptionofunits"
          ? transaction?.remain_holding
          : transaction?.total_holding;
    } else if (
      selectedCol?.label?.includes("date") ||
      selectedCol?.label?.includes("Date") ||
      selectedCol?.label?.includes("Expense To") ||
      selectedCol?.label?.includes("Expense From") ||
      selectedCol?.label?.includes("Settlement")
    ) {
      res = moment(transaction[selectedCol?.value])?.format("DD-MMM-YYYY");
    } else if (
      selectedCol.value === "gross_amount" ||
      selectedCol.value === "net_amount" ||
      selectedCol.value === "sale_load" ||
      selectedCol.value === "units" ||
      selectedCol.value === "refund_of_capital" ||
      selectedCol.value === "current_holding" ||
      selectedCol.value === "total_holding" ||
      selectedCol.value === "remain_holding" ||
      selectedCol.value === "balance" ||
      selectedCol.value === "face_value" ||
      selectedCol.value === "applicable_offer_price" ||
      selectedCol.value === "offer_price" ||
      selectedCol.value === "redemption_load" ||
      selectedCol.value === "tax_cgt" ||
      selectedCol.value === "tax_wht_it" ||
      selectedCol.value == "zakat_amount" ||
      selectedCol.value === "joint_holder_income_tax" ||
      selectedCol.value === "income_tax" ||
      selectedCol.val === "dividend_rate" ||
      selectedCol.value === "tax_sst" ||
      selectedCol.value === "total_charges" ||
      selectedCol.value === "tax_wht_it" ||
      selectedCol.value === "tax_wht_sst" ||
      selectedCol.value === "bonus_gross_volume" ||
      selectedCol.value === "tax_it_bonus_amount" ||
      selectedCol.value === "net_bonus_volume" ||
      selectedCol.value === "right_share_gross_volume" ||
      selectedCol.value === "tax_it_right_share_amount" ||
      selectedCol.value === "net_right_share_volume"
    ) {
      res = numberWithCommas(transaction[selectedCol.value]?.toFixed(4) || "0");
    }

    return res;
  };

  // const renderDropdownValues = (index = 0, selectedCol, transaction) => {

  //   const InArr = [
  //     "saleofunit",
  //     "conversionin"
  //   ]

  //   let res = transaction[selectedCol.value];
  //   if (
  //     selectedCol?.label?.includes("S No")
  //   ) {
  //     res = index
  //   }
  //   if (
  //     selectedCol?.label?.includes("IN/OUT")
  //   ) {
  //     res = InArr?.includes(transaction?.txnr_type) ? "IN" : "OUT"
  //   }
  //   if (
  //     selectedCol?.label?.includes("PRU/RDU")
  //   ) {
  //     res = InArr?.includes(transaction?.txnr_type) ? "PRU" : "RDU"
  //   }
  //   if (
  //     selectedCol?.label?.includes("UIN/NTN")
  //   ) {
  //     res = transaction?.ntn || transaction?.cnic || ""
  //   }
  //   if (
  //     selectedCol?.label?.includes("UIN/NTN")
  //   ) {
  //     res = transaction?.unithodlerCNIC || transaction?.unithodlerNTN || ""
  //   }
  //   if (
  //     selectedCol?.label?.includes("Account No")
  //   ) {
  //     res = transaction?.folio_no?.replaceAll("DL-", "")
  //   }

  //   if (
  //     selectedCol?.label?.includes("UNIT Balance After")
  //   ) {
  //     res = (transaction?.txnr_type === "conversionout" || transaction?.txnr_type === "redemptionofunits") ? `rh-${transaction?.remain_holding}` : transaction?.total_holding
  //     console.log("ressss", res)
  //   }

  //   if (
  //     selectedCol?.label?.includes("date") ||
  //     selectedCol?.label?.includes("Date") ||
  //     selectedCol?.label?.includes("Expense To") ||
  //     selectedCol?.label?.includes("Expense From") ||
  //     selectedCol?.label?.includes("Settlement")
  //   ) {
  //     res = moment(transaction[selectedCol?.value])?.format("DD-MMM-YYYY");
  //   }
  //   if (
  //     selectedCol.value === "gross_amount" ||
  //     selectedCol.value === "net_amount" ||
  //     selectedCol.value === "sale_load" ||
  //     selectedCol.value === "units" ||
  //     selectedCol.value === "refund_of_capital" ||
  //     selectedCol.value === "current_holding" ||
  //     selectedCol.value === "total_holding" ||
  //     selectedCol.value === "remain_holding" ||
  //     selectedCol.value === "balance" ||
  //     selectedCol.value === "face_value" ||
  //     selectedCol.value === "applicable_offer_price" ||
  //     selectedCol.value === "offer_price" ||
  //     selectedCol.value === "redemption_load" ||
  //     selectedCol.value === "tax_cgt" ||
  //     selectedCol.value === "tax_wht_it" ||
  //     selectedCol.value == "zakat_amount" ||
  //     selectedCol.value === "joint_holder_income_tax" ||
  //     selectedCol.value === "income_tax" ||
  //     selectedCol.val === "dividend_rate" ||
  //     selectedCol.value === "tax_sst" ||
  //     selectedCol.value === "total_charges" ||
  //     selectedCol.value === "tax_wht_it" ||
  //     selectedCol.value === "tax_wht_sst" ||
  //     selectedCol.value === "bonus_gross_volume" ||
  //     selectedCol.value === "tax_it_bonus_amount" ||
  //     selectedCol.value === "net_bonus_volume" ||
  //     selectedCol.value === "right_share_gross_volume" ||
  //     selectedCol.value === "tax_it_right_share_amount" ||
  //     selectedCol.value === "net_right_share_volume"
  //   ) {
  //     res = numberWithCommas(transaction[selectedCol.value]?.toFixed(4) || "0");
  //   }
  //   // if (selectedCol.value === 'txnr_type') {
  //   //   res = CapTxnType(transaction[selectedCol.value]);
  //   // }

  //   return res;
  // };

  //code for search data for Reports
  const searchData = async () => {
    setIsSearchTrue(false);
    setLoading(true);
    setItemsPerPage(10);
    setReportTxn([]);
    try {
      const searchResponse = await getTransactionReportSearchData(
        email,
        fields,
      );
      setResAmc(amc_name);
      setResFund(fields["fund_code"]);
      setFromDate(fields["from_date"]);
      setToDate(fields["to_date"]);
      setTxnType(fields["txn_type"]);
      setStatus(fields["status"]);
      if (fields["txn_type"] === "debtmarketinvestment") {
        let TransactionsBucket: any = [];
        searchResponse.data.data.forEach((transaction: any, index: number) => {
          let securities = JSON.parse(transaction.securities);

          securities.forEach((security) => {
            let transactionToReturn = {
              ...transaction,
              issue_date: security.issue_date,
              security_type: security.security_type,
            };
            TransactionsBucket.push(transactionToReturn);
          });
        });
        setReportTxn(TransactionsBucket);
      } else {
        setReportTxn(searchResponse.data.data);
      }
      let temp = Object.keys(searchResponse.data.data[0]).map((val) => {
        return { label: formatData(val), value: val };
      });
      // setAllDropdownColumns(temp);
      const resolvedColumns =
        distName === "nccpl"
          ? NCCPL_COLUMN_ORDER.filter((col) => col.label !== "NCCPL_EMPTY_COL")
          : headerColumns;

      setDropdownList(resolvedColumns);
      setAllDropdownColumns(resolvedColumns);
      setColumnArr(resolvedColumns);

      let data: any = [];
      let netamount = 0,
        grossamount = 0,
        saleload = 0,
        cgt = 0,
        redemptionload = 0,
        units = 0,
        current_holding = 0,
        tax_wht_it = 0,
        zakat_amount = 0,
        tax_wht_sst = 0,
        tax_sst = 0,
        totalAmount = 0,
        net_right_share_volume = 0,
        tax_it_right_share_amount = 0,
        right_share_gross_volume = 0,
        tax_it_bonus_amount = 0,
        net_bonus_volume = 0;
      data = searchResponse.data.data;
      if (
        fields["txn_type"] === "saleofunit" ||
        fields["txn_type"] === "conversionin"
      ) {
        data.map((item: any, index: number) => {
          netamount += parseFloat(item.net_amount || "0");
          grossamount += parseFloat(item.gross_amount || "0");
          saleload += parseFloat(item.sale_load || "0");
          units += parseFloat(item.units || "0");
          current_holding += parseFloat(item.current_holding || "0");
        });
      } else if (
        fields["txn_type"] === "redemptionofunits" ||
        fields["txn_type"] === "conversionout"
      ) {
        data.map((item: any, index: number) => {
          netamount += parseFloat(item.net_amount || "0");
          grossamount += parseFloat(item.gross_amount || "0");
          // saleload+=parseFloat(item.sale_load || '0');
          cgt += parseFloat(item.tax_cgt || "0");
          redemptionload += parseFloat(item.redemption_load || "0");
          units += parseFloat(item.units || "0");
          current_holding += parseFloat(item.current_holding || "0");
        });
      } else if (
        fields["txn_type"] === "inflow" ||
        fields["txn_type"] === "outflow" ||
        fields["txn_type"] === "fundtransfer" ||
        fields["txn_type"] === "bankprofit" ||
        fields["txn_type"] === "cashmargin" ||
        fields["txn_type"] === "marginreturn"
      ) {
        data.map((item: any, index: number) => {
          netamount += parseFloat(item.net_amount || "0");
          grossamount += parseFloat(item.gross_amount || "0");
        });
      } else if (fields["txn_type"] === "funddividendpayout") {
        data.map((item: any, index: number) => {
          netamount += parseFloat(item.net_amount || "0");
          grossamount += parseFloat(item.gross_amount || "0");
          units += parseFloat(item.units || "0");
          current_holding += parseFloat(item.current_holding || "0");
          tax_wht_it += parseFloat(item.tax_wht_it || "0");
          zakat_amount += parseFloat(item.zakat_amount || "0");
        });
      } else if (fields["txn_type"] === "debtmarketinvestment") {
        data.map((item: any, index: number) => {
          grossamount += parseFloat(item.gross_amount || "0");
        });
      } else if (fields["txn_type"] === "equityinvestment") {
        data.map((item: any, index: number) => {
          netamount += parseFloat(item.net_amount || "0");
          grossamount += parseFloat(item.gross_amount || "0");
          tax_sst += parseFloat(item.tax_sst || "0");
        });
      } else if (fields["txn_type"] === "cashdividend") {
        data.map((item: any, index: number) => {
          netamount += parseFloat(item.net_amount || "0");
          grossamount += parseFloat(item.gross_amount || "0");
          tax_wht_it += parseFloat(item.tax_wht_it || "0");
          net_right_share_volume += parseFloat(
            item.net_right_share_volume || "0",
          );
          tax_it_right_share_amount += parseFloat(
            item.tax_it_right_share_amount || "0",
          );
          right_share_gross_volume += parseFloat(
            item.right_share_gross_volume || "0",
          );
          net_bonus_volume += parseFloat(item.net_bonus_volume || "0");
          tax_it_bonus_amount += parseFloat(item.tax_it_bonus_amount || "0");
        });
      } else if (
        fields["txn_type"] === "advisoryfee" ||
        fields["txn_type"] === "auditorsfee" ||
        fields["txn_type"] === "bankcharges" ||
        fields["txn_type"] === "managementfee" ||
        fields["txn_type"] === "trusteefee" ||
        fields["txn_type"] === "custodyfee" ||
        fields["txn_type"] === "shariahadvisoryfee" ||
        fields["txn_type"] === "cdcfee" ||
        fields["txn_type"] === "listingfee" ||
        fields["txn_type"] === "printingfee" ||
        fields["txn_type"] === "professionalfee" ||
        fields["txn_type"] === "ratingfee" ||
        fields["txn_type"] === "taxpayment" ||
        fields["txn_type"] === "secpfee" ||
        fields["txn_type"] === "brokagefee" ||
        fields["txn_type"] === "otherpayment"
      ) {
        data.map((item: any, index: number) => {
          netamount += parseFloat(item.net_amount || "0");
          grossamount += parseFloat(item.gross_amount || "0");
          tax_sst += parseFloat(item.tax_sst || "0");
          totalAmount += parseFloat(item.total_charges || "0");
          tax_wht_it += parseFloat(item.tax_wht_it || "0");
          tax_wht_sst += parseFloat(item.tax_wht_sst || "0");
        });
      }
      setTotalNetAmount(netamount.toFixed(4));
      setTotalGrossAmount(grossamount.toFixed(4));
      setTotalSaleLoad(saleload.toFixed(4));
      setTotalRedemptionLoad(redemptionload.toFixed(4));
      setTotalCGT(cgt.toFixed(4));
      setTotalUnits(units.toFixed(4));
      setTotalCurrentHolding(current_holding.toFixed(4));
      setTotalWH_IT(tax_wht_it.toFixed(4));
      setTotalZakatAmount(zakat_amount.toFixed(4));
      setTotalTax_SST(tax_sst.toFixed(4));
      setTotalWH_IT(tax_wht_it.toFixed(4));
      setTotalWH_SST(tax_wht_sst.toFixed(4));
      setTotalAmount(totalAmount.toFixed(4));
      setNetRightShareVolume(net_right_share_volume.toFixed(4));
      setTotalTaxITRightShareAmount(tax_it_right_share_amount.toFixed(4));
      setTotalRightShareGrossVolume(right_share_gross_volume.toFixed(4));
      setTotalNetBonusVolume(net_bonus_volume.toFixed(4));
      setTotalTaxItBonusAmount(tax_it_bonus_amount.toFixed(4));
      setLoading(false);
      setIsSearchTrue(true);
      setFontSizeVal(18);
    } catch (error) {
      setReportTxn([]);
      setLoading(false);
    }
  };

  const stylesTxnDropdown = {
    valueContainer: (provided, state) => ({
      ...provided,
      textOverflow: "ellipsis",
      maxWidth: "90%",
      whiteSpace: "nowrap",
      overflow: "hidden",
      display: "initial",
      backgroundColor: "blue",
    }),
  };

  const selectedTransactionStatus = React.useMemo(() => {
    const selectedFund = transaction_Status?.find(
      (item) => item?.value === fields["status"],
    );
    return selectedFund
      ? {
          value: selectedFund.value,
          label: selectedFund.label,
        }
      : null;
  }, [fields["status"]]);

  const selectedTransactionType = React.useMemo(() => {
    const selectedFund =
      txnTypes?.length > 0 &&
      txnTypes?.find((item) => item?.api_name === fields["txn_type"]);
    return selectedFund
      ? {
          value: selectedFund.api_name,
          label: selectedFund.dis_name,
        }
      : null;
  }, [txnTypes, fields["txn_type"]]);

  const selectedFund = React.useMemo(() => {
    const selectedFund =
      allFunds?.length > 0 &&
      allFunds?.find((item) => item?.symbol_code === fields["fund_code"]);
    return selectedFund
      ? {
          value: selectedFund.symbol_code,
          label: `${selectedFund.fund_name} - ${selectedFund.symbol_code}`,
        }
      : null;
  }, [allFunds, fields["fund_code"]]);

  useEffect(() => {
    if (reportTxn?.length > 0) {
      let netamount = 0,
        grossamount = 0,
        saleload = 0,
        cgt = 0,
        redemptionload = 0,
        units = 0,
        current_holding = 0,
        tax_wht_it = 0,
        zakat_amount = 0,
        tax_wht_sst = 0,
        tax_sst = 0,
        totalAmount = 0,
        net_right_share_volume = 0,
        tax_it_right_share_amount = 0,
        right_share_gross_volume = 0,
        tax_it_bonus_amount = 0,
        net_bonus_volume = 0;
      let data = reportTxn?.slice(0, itemsToShow);
      if (
        fields["txn_type"] === "saleofunit" ||
        fields["txn_type"] === "conversionin"
      ) {
        data.map((item: any, index: number) => {
          netamount += parseFloat(item.net_amount || "0");
          grossamount += parseFloat(item.gross_amount || "0");
          saleload += parseFloat(item.sale_load || "0");
          units += parseFloat(item.units || "0");
          current_holding += parseFloat(item.current_holding || "0");
        });
      } else if (
        fields["txn_type"] === "redemptionofunits" ||
        fields["txn_type"] === "conversionout"
      ) {
        data.map((item: any, index: number) => {
          netamount += parseFloat(item.net_amount || "0");
          grossamount += parseFloat(item.gross_amount || "0");
          // saleload+=parseFloat(item.sale_load || '0');
          cgt += parseFloat(item.tax_cgt || "0");
          redemptionload += parseFloat(item.redemption_load || "0");
          units += parseFloat(item.units || "0");
          current_holding += parseFloat(item.current_holding || "0");
        });
      } else if (
        fields["txn_type"] === "inflow" ||
        fields["txn_type"] === "outflow" ||
        fields["txn_type"] === "fundtransfer" ||
        fields["txn_type"] === "bankprofit" ||
        fields["txn_type"] === "cashmargin" ||
        fields["txn_type"] === "marginreturn"
      ) {
        data.map((item: any, index: number) => {
          netamount += parseFloat(item.net_amount || "0");
          grossamount += parseFloat(item.gross_amount || "0");
        });
      } else if (fields["txn_type"] === "funddividendpayout") {
        data.map((item: any, index: number) => {
          netamount += parseFloat(item.net_amount || "0");
          grossamount += parseFloat(item.gross_amount || "0");
          units += parseFloat(item.units || "0");
          current_holding += parseFloat(item.current_holding || "0");
          tax_wht_it += parseFloat(item.tax_wht_it || "0");
          zakat_amount += parseFloat(item.zakat_amount || "0");
        });
      } else if (fields["txn_type"] === "debtmarketinvestment") {
        data.map((item: any, index: number) => {
          grossamount += parseFloat(item.gross_amount || "0");
        });
      } else if (fields["txn_type"] === "equityinvestment") {
        data.map((item: any, index: number) => {
          netamount += parseFloat(item.net_amount || "0");
          grossamount += parseFloat(item.gross_amount || "0");
          tax_sst += parseFloat(item.tax_sst || "0");
        });
      } else if (fields["txn_type"] === "cashdividend") {
        data.map((item: any, index: number) => {
          netamount += parseFloat(item.net_amount || "0");
          grossamount += parseFloat(item.gross_amount || "0");
          tax_wht_it += parseFloat(item.tax_wht_it || "0");
          net_right_share_volume += parseFloat(
            item.net_right_share_volume || "0",
          );
          tax_it_right_share_amount += parseFloat(
            item.tax_it_right_share_amount || "0",
          );
          right_share_gross_volume += parseFloat(
            item.right_share_gross_volume || "0",
          );
          net_bonus_volume += parseFloat(item.net_bonus_volume || "0");
          tax_it_bonus_amount += parseFloat(item.tax_it_bonus_amount || "0");
        });
      } else if (
        fields["txn_type"] === "advisoryfee" ||
        fields["txn_type"] === "auditorsfee" ||
        fields["txn_type"] === "bankcharges" ||
        fields["txn_type"] === "managementfee" ||
        fields["txn_type"] === "trusteefee" ||
        fields["txn_type"] === "custodyfee" ||
        fields["txn_type"] === "shariahadvisoryfee" ||
        fields["txn_type"] === "cdcfee" ||
        fields["txn_type"] === "listingfee" ||
        fields["txn_type"] === "printingfee" ||
        fields["txn_type"] === "professionalfee" ||
        fields["txn_type"] === "ratingfee" ||
        fields["txn_type"] === "taxpayment" ||
        fields["txn_type"] === "secpfee" ||
        fields["txn_type"] === "brokagefee" ||
        fields["txn_type"] === "otherpayment"
      ) {
        data.map((item: any, index: number) => {
          netamount += parseFloat(item.net_amount || "0");
          grossamount += parseFloat(item.gross_amount || "0");
          tax_sst += parseFloat(item.tax_sst || "0");
          totalAmount += parseFloat(item.total_charges || "0");
          tax_wht_it += parseFloat(item.tax_wht_it || "0");
          tax_wht_sst += parseFloat(item.tax_wht_sst || "0");
        });
      }
      setTotalNetAmount(netamount.toFixed(4));
      setTotalGrossAmount(grossamount.toFixed(4));
      setTotalSaleLoad(saleload.toFixed(4));
      setTotalRedemptionLoad(redemptionload.toFixed(4));
      setTotalCGT(cgt.toFixed(4));
      setTotalUnits(units.toFixed(4));
      setTotalCurrentHolding(current_holding.toFixed(4));
      setTotalWH_IT(tax_wht_it.toFixed(4));
      setTotalZakatAmount(zakat_amount.toFixed(4));
      setTotalTax_SST(tax_sst.toFixed(4));
      setTotalWH_IT(tax_wht_it.toFixed(4));
      setTotalWH_SST(tax_wht_sst.toFixed(4));
      setTotalAmount(totalAmount.toFixed(4));
      setNetRightShareVolume(net_right_share_volume.toFixed(4));
      setTotalTaxITRightShareAmount(tax_it_right_share_amount.toFixed(4));
      setTotalRightShareGrossVolume(right_share_gross_volume.toFixed(4));
      setTotalNetBonusVolume(net_bonus_volume.toFixed(4));
      setTotalTaxItBonusAmount(tax_it_bonus_amount.toFixed(4));
    }
  }, [itemsToShow, reportTxn]);

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
          ? "hsla(291, 64%, 42%, 1)"
          : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
          ? "#2b3553"
          : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
      '& .react-select__input input[type="color"]': {
        color: theme === "dark" ? "red" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  useEffect(() => {
    const elements = document.querySelectorAll(
      "#test",
    ) as NodeListOf<HTMLElement>;
    elements.forEach((element) => {
      element.style.setProperty("font-size", `${fontSizeVal}px`, "important");
    });
  }, [fontSizeVal, itemsToShow, selectedValues, isSearchTrue]);

  const handleDownloadSampleFile = () => {
    const fixedOrder =
      distName === "nccpl"
        ? [...NCCPL_COLUMN_ORDER.map((item) => item.label), "Semi_Colon"]
        : ColumnArr?.map((item) => `${item?.label}`);
    const headings = [
      [selectedValues?.heading ? selectedValues?.heading : "", "", "", ""],
      [
        selectedValues?.sub_heading ? selectedValues?.sub_heading : "",
        "",
        "",
        "",
      ],
      [
        "Fund",
        `${resFund}`,
        "Transaction Type",
        ` ${distName === "nccpl" ? "NCCPL" : CapTxnType(txn_type)}`,
      ],
      [
        "From Date",
        `${moment(from_date).format("DD-MM-YYYY")}`,
        "To Date",
        `${
          moment(to_date).format("DD-MM-YYYY") === "Invalid date"
            ? to_date
            : moment(to_date).format("DD-MM-YYYY")
        }`,
      ],
      [
        "Status",
        `${status}`,
        "Report Date",
        `${moment(date).format("DD-MM-YYYY")}`,
      ],
    ];
    let dataSequence = reportTxn
      ?.slice(0, itemsToShow)
      .map((transaction, index) => {
        const rowData = {};
        dropdownList.forEach((item) => {
          if (selectedValues.columns.includes(item.label)) {
            rowData[item.label] = renderDropdownValues(
              index + 1,
              item,
              transaction,
            );
          }
        });
        return rowData;
      });

    if (distName !== "nccpl") {
      const footerData = {};
      dropdownList.forEach((item) => {
        if (selectedValues.columns.includes(item.label)) {
          if (item.value === "net_amount") {
            footerData[item.label] = numberWithCommas(totalNetAmount);
          } else if (item.value === "gross_amount") {
            footerData[item.label] = numberWithCommas(totalGrossAmount);
          } else if (item.value === "sale_load") {
            footerData[item.label] = numberWithCommas(totalSaleLoad);
          } else if (item.value === "tax_cgt") {
            footerData[item.label] = numberWithCommas(totalCGT);
          } else if (item.value === "redemption_load") {
            footerData[item.label] = numberWithCommas(totalRedemptionLoad);
          } else if (item.value === "units") {
            footerData[item.label] = numberWithCommas(totalUnits);
          } else if (item.value === "current_holding") {
            footerData[item.label] = numberWithCommas(totalCurrentHolding);
          } else if (item.value === "zakat_amount") {
            footerData[item.label] = numberWithCommas(totalZakatAmount);
          } else if (item.value === "tax_wht_it") {
            footerData[item.label] = numberWithCommas(totalWHT_II);
          } else if (item.value === "tax_wht_sst") {
            footerData[item.label] = numberWithCommas(totalWHT_SST);
          } else if (item.value === "tax_sst") {
            footerData[item.label] = numberWithCommas(totalTax_SST);
          } else if (item.value === "total_charges") {
            footerData[item.label] = numberWithCommas(totalTotalAmount);
          } else if (item.value === "tax_it_bonus_amount") {
            footerData[item.label] = numberWithCommas(
              totalTotalTaxItBonusAmount,
            );
          } else if (item.value === "net_bonus_volume") {
            footerData[item.label] = numberWithCommas(totalTotatNetBonusVolume);
          } else if (item.value === "right_share_gross_volume") {
            footerData[item.label] = numberWithCommas(
              totalRightShareGrossVolume,
            );
          } else if (item.value === "tax_it_right_share_amount") {
            footerData[item.label] = numberWithCommas(
              totalTaxITRightShareAmount,
            );
          } else if (item.value === "net_right_share_volume") {
            footerData[item.label] = numberWithCommas(totalNetRightShareVolume);
          } else {
            footerData[item.label] = "";
          }
        }
      });

      dataSequence?.push(footerData);
    }

    const reorderColumns = (columns, order) => {
      let newColumns =
        distName === "nccpl" ? [...columns, "Semi_Colon"] : [...columns];
      return order.filter((column) => newColumns?.includes(column));
    };

    const reorderedColumn: any = reorderColumns(
      selectedValues?.columns,
      fixedOrder,
    );
    let reorderedColumns: any = Array.from(new Set(reorderedColumn));

    const ArrayData =
      selectedValues?.columns?.length > 0 &&
      dataSequence?.map((entry) => {
        const transformedEntry: any = Object.keys(entry).reduce((acc, key) => {
          const newKey = key
            .replaceAll(" ", "_")
            ?.replaceAll("/", "")
            ?.replace(".", "");
          acc[newKey] = entry[key];
          return acc;
        }, {});

        const result = {};
        reorderedColumns.forEach((columns) => {
          let column = columns?.trim();
          if (column === "TXN ID") {
            result[column] = transformedEntry?.TXN_ID;
          } else if (column === "Transaction ID") {
            result[column] = transformedEntry?.Transaction_ID;
          } else if (column === "AMC") {
            result[column] = transformedEntry?.AMC;
          } else if (column === "Creation Date") {
            result[column] = transformedEntry?.Creation_Date;
          } else if (
            column === "Execution Date" ||
            column === "Execution date"
          ) {
            result[column] = transformedEntry?.Execution_date;
          } else if (column === "folio no") {
            result[column] = transformedEntry?.folio_no;
          } else if (column === "Fund A/C No.") {
            result[column] = transformedEntry?.Fund_AC_No;
          } else if (column === "Nav") {
            result[column] = transformedEntry?.Nav_;
          } else if (column === "Fund Bank" || column === "fund bank") {
            result[column] = transformedEntry?.fund_bank_;
          } else if (column === "Fund Branch" || column === "fund branch") {
            result[column] = transformedEntry?.fund_branch_;
          } else if (column === "Fund IBAN" || column === "fund IBAN") {
            result[column] = transformedEntry?.fund_IBAN;
          } else if (column === "To Bank" || column === "To bank") {
            result[column] = transformedEntry?.To_bank;
          } else if (column === "To Account") {
            result[column] = transformedEntry?.To_Account;
          } else if (column === "To Account Title") {
            result[column] = transformedEntry?.To_Account_Title;
          } else if (
            column === "Mode Of Payment" ||
            column === "mode of payment"
          ) {
            result[column] = transformedEntry?.mode_of_payment;
          } else if (column === "Gross Amount") {
            result[column] = transformedEntry?.Gross_Amount;
          } else if (column === "SST") {
            result[column] = transformedEntry?.SST;
          } else if (column === "Total Amount") {
            result[column] = transformedEntry?.Total_Amount;
          } else if (column === "WH IT") {
            result[column] = transformedEntry?.WH_IT;
          } else if (column === "WH ST") {
            result[column] = transformedEntry?.WH_ST;
          } else if (column === "Net Amount" || column === "Net amount") {
            result[column] = transformedEntry?.Net_amount;
          } else if (column === "Detail") {
            result[column] = transformedEntry?.Detail;
          } else if (column === "fund code") {
            result[column] = transformedEntry?.fund_code;
          } else if (column === "unitholder") {
            result[column] = transformedEntry?.unitholder;
          } else if (column === "Sale Date") {
            result[column] = transformedEntry?.Sale_Date;
          } else if (column === "Fund Name") {
            result[column] = transformedEntry?.Fund_Name;
          } else if (column === "Fund A/C Title") {
            result[column] = transformedEntry?.Fund_AC_Title;
          } else if (column === "Fund A/C No.") {
            result[column] = transformedEntry?.Fund_AC_No;
          } else if (column === "Offer Price") {
            result[column] = transformedEntry?.Offer_Price;
          } else if (column === "Discount on Load") {
            result[column] = transformedEntry?.Discount_on_Load;
          } else if (column === "Load Per Unit") {
            result[column] = transformedEntry?.Load_Per_Unit;
          } else if (column === "Applicable Offer Price") {
            result[column] = transformedEntry?.Applicable_Offer_Price;
          } else if (column === "Drawer bank") {
            result[column] = transformedEntry?.Drawer_bank;
          } else if (column === "Drawer IBAN") {
            result[column] = transformedEntry?.Drawer_IBAN;
          } else if (column === "Received Amount") {
            result[column] = transformedEntry?.Received_Amount;
          } else if (column === "Sale Load") {
            result[column] = transformedEntry?.Sale_Load;
          } else if (column === "Net Sale amount") {
            result[column] = transformedEntry?.Net_Sale_amount;
          } else if (column === "Units Sold") {
            result[column] = transformedEntry?.Units_Sold;
          } else if (column === "Current Holding") {
            result[column] = transformedEntry?.Current_Holding;
          } else if (column === "Oustanding Units") {
            result[column] = transformedEntry?.Oustanding_Units;
          } else if (column === "Created By") {
            result[column] = transformedEntry?.Created_By;
          }
          // nccpl report
          else if (column === "Date") {
            result[column] = transformedEntry?.Date;
          } else if (column === "Transaction ID Name") {
            result[column] = transformedEntry?.Transaction_ID_Name;
          } else if (column === "S No") {
            result[column] = transformedEntry?.S_No;
          } else if (column === "Settlement") {
            result[column] = transformedEntry?.Settlement;
          } else if (column === "IN/OUT") {
            result[column] = transformedEntry?.INOUT;
          } else if (column === "Inventory Date") {
            result[column] = transformedEntry?.Inventory_Date;
          } else if (column === "PRU/RDU") {
            result[column] = transformedEntry?.PRURDU;
          } else if (column === "Fund ID") {
            result[column] = transformedEntry?.Fund_ID;
          } else if (column === "FUND CODE") {
            result[column] = transformedEntry?.FUND_CODE;
          } else if (column === "UIN/NTN") {
            result[column] = transformedEntry?.UINNTN;
          } else if (column === "Account No") {
            result[column] = transformedEntry?.Account_No;
          } else if (column === "Units IN/OUT") {
            result[column] = transformedEntry?.Units_INOUT;
          } else if (column === "NAV Price Price") {
            result[column] = transformedEntry?.NAV_Price_Price;
          } else if (column === "Counter Transaction") {
            result[column] = transformedEntry?.Counter_Transaction;
          } else if (column === "NCC REF") {
            result[column] = transformedEntry?.NCC_REF;
          } else if (column === "GAIN/LOSS") {
            result[column] = transformedEntry?.GAINLOSS;
          } else if (column === "CGT AMOUNT") {
            result[column] = transformedEntry?.CGT_AMOUNT;
          } else if (column === "UNIT Balance Before") {
            result[column] = transformedEntry?.UNIT_Balance_Before;
          } else if (column === "UNIT Balance After") {
            result[column] = transformedEntry?.UNIT_Balance_After;
          } else if (column === "Dividend Gain Info") {
            result[column] = transformedEntry?.Dividend_Gain_Info;
          } else if (column === "Semi_Colon") {
            result[column] = ";";
          }
        });

        return result;
      });

    generateExcel(
      distName === "nccpl" ? "NCCPL Report" : "Transaction Report",
      distName === "nccpl" ? "NCCPL Report" : "Transaction Report",
      "File",
      "File",
      "DCCL",
      distName === "nccpl" ? [] : headings,
      reorderedColumns,
      ArrayData,
      [],
      [],
    );
  };

  const handleTXT = () => {
    const fixedOrder = ColumnArr?.map((item) => `${item?.label}`);
    if (distName === "nccpl") {
      fixedOrder?.push("Semi_Colon");
    }
    let dataSequence = reportTxn
      ?.slice(0, itemsToShow)
      .map((transaction, index) => {
        const rowData = {};
        dropdownList.forEach((item) => {
          if (selectedValues.columns.includes(item.label)) {
            rowData[item.label] = renderDropdownValues(
              index + 1,
              item,
              transaction,
            );
          }
        });
        return rowData;
      });

    if (distName !== "nccpl") {
      const footerData = {};
      dropdownList.forEach((item) => {
        if (selectedValues.columns.includes(item.label)) {
          if (item.value === "net_amount") {
            footerData[item.label] = numberWithCommas(totalNetAmount);
          } else if (item.value === "gross_amount") {
            footerData[item.label] = numberWithCommas(totalGrossAmount);
          } else if (item.value === "sale_load") {
            footerData[item.label] = numberWithCommas(totalSaleLoad);
          } else if (item.value === "tax_cgt") {
            footerData[item.label] = numberWithCommas(totalCGT);
          } else if (item.value === "redemption_load") {
            footerData[item.label] = numberWithCommas(totalRedemptionLoad);
          } else if (item.value === "units") {
            footerData[item.label] = numberWithCommas(totalUnits);
          } else if (item.value === "current_holding") {
            footerData[item.label] = numberWithCommas(totalCurrentHolding);
          } else if (item.value === "zakat_amount") {
            footerData[item.label] = numberWithCommas(totalZakatAmount);
          } else if (item.value === "tax_wht_it") {
            footerData[item.label] = numberWithCommas(totalWHT_II);
          } else if (item.value === "tax_wht_sst") {
            footerData[item.label] = numberWithCommas(totalWHT_SST);
          } else if (item.value === "tax_sst") {
            footerData[item.label] = numberWithCommas(totalTax_SST);
          } else if (item.value === "total_charges") {
            footerData[item.label] = numberWithCommas(totalTotalAmount);
          } else if (item.value === "tax_it_bonus_amount") {
            footerData[item.label] = numberWithCommas(
              totalTotalTaxItBonusAmount,
            );
          } else if (item.value === "net_bonus_volume") {
            footerData[item.label] = numberWithCommas(totalTotatNetBonusVolume);
          } else if (item.value === "right_share_gross_volume") {
            footerData[item.label] = numberWithCommas(
              totalRightShareGrossVolume,
            );
          } else if (item.value === "tax_it_right_share_amount") {
            footerData[item.label] = numberWithCommas(
              totalTaxITRightShareAmount,
            );
          } else if (item.value === "net_right_share_volume") {
            footerData[item.label] = numberWithCommas(totalNetRightShareVolume);
          } else {
            footerData[item.label] = "";
          }
        }
      });

      dataSequence?.push(footerData);
    }

    const reorderColumns = (columns, order) => {
      let newColumns =
        distName === "nccpl" ? [...columns, "Semi_Colon"] : [...columns];
      return order.filter((column) => newColumns?.includes(column));
    };

    const reorderedColumn: any = reorderColumns(
      selectedValues?.columns,
      fixedOrder,
    );
    let reorderedColumns: any = Array.from(new Set(reorderedColumn));

    const ArrayData =
      selectedValues?.columns?.length > 0 &&
      dataSequence?.map((entry) => {
        const transformedEntry: any = Object.keys(entry).reduce((acc, key) => {
          const newKey = key
            .replaceAll(" ", "_")
            ?.replaceAll("/", "")
            ?.replace(".", "");
          acc[newKey] = entry[key];
          return acc;
        }, {});

        const result = {};
        reorderedColumns.forEach((columns) => {
          let column = columns?.trim();
          if (column === "TXN ID") {
            result[column] = transformedEntry?.TXN_ID;
          } else if (column === "Transaction ID") {
            result[column] = transformedEntry?.Transaction_ID;
          } else if (column === "AMC") {
            result[column] = transformedEntry?.AMC;
          } else if (column === "Creation Date") {
            result[column] = transformedEntry?.Creation_Date;
          } else if (
            column === "Execution Date" ||
            column === "Execution date"
          ) {
            result[column] = transformedEntry?.Execution_date;
          } else if (column === "folio no") {
            result[column] = transformedEntry?.folio_no;
          } else if (column === "Fund A/C No.") {
            result[column] = transformedEntry?.Fund_AC_No;
          } else if (column === "Nav") {
            result[column] = transformedEntry?.Nav_;
          } else if (column === "Fund Bank" || column === "fund bank") {
            result[column] = transformedEntry?.fund_bank_;
          } else if (column === "Fund Branch" || column === "fund branch") {
            result[column] = transformedEntry?.fund_branch_;
          } else if (column === "Fund IBAN" || column === "fund IBAN") {
            result[column] = transformedEntry?.fund_IBAN;
          } else if (column === "To Bank" || column === "To bank") {
            result[column] = transformedEntry?.To_bank;
          } else if (column === "To Account") {
            result[column] = transformedEntry?.To_Account;
          } else if (column === "To Account Title") {
            result[column] = transformedEntry?.To_Account_Title;
          } else if (
            column === "Mode Of Payment" ||
            column === "mode of payment"
          ) {
            result[column] = transformedEntry?.mode_of_payment;
          } else if (column === "Gross Amount") {
            result[column] = transformedEntry?.Gross_Amount;
          } else if (column === "SST") {
            result[column] = transformedEntry?.SST;
          } else if (column === "Total Amount") {
            result[column] = transformedEntry?.Total_Amount;
          } else if (column === "WH IT") {
            result[column] = transformedEntry?.WH_IT;
          } else if (column === "WH ST") {
            result[column] = transformedEntry?.WH_ST;
          } else if (column === "Net Amount" || column === "Net amount") {
            result[column] = transformedEntry?.Net_amount;
          } else if (column === "Detail") {
            result[column] = transformedEntry?.Detail;
          } else if (column === "fund code") {
            result[column] = transformedEntry?.fund_code;
          } else if (column === "unitholder") {
            result[column] = transformedEntry?.unitholder;
          } else if (column === "Sale Date") {
            result[column] = transformedEntry?.Sale_Date;
          } else if (column === "Fund Name") {
            result[column] = transformedEntry?.Fund_Name;
          } else if (column === "Fund A/C Title") {
            result[column] = transformedEntry?.Fund_AC_Title;
          } else if (column === "Fund A/C No.") {
            result[column] = transformedEntry?.Fund_AC_No;
          } else if (column === "Offer Price") {
            result[column] = transformedEntry?.Offer_Price;
          } else if (column === "Discount on Load") {
            result[column] = transformedEntry?.Discount_on_Load;
          } else if (column === "Load Per Unit") {
            result[column] = transformedEntry?.Load_Per_Unit;
          } else if (column === "Applicable Offer Price") {
            result[column] = transformedEntry?.Applicable_Offer_Price;
          } else if (column === "Drawer bank") {
            result[column] = transformedEntry?.Drawer_bank;
          } else if (column === "Drawer IBAN") {
            result[column] = transformedEntry?.Drawer_IBAN;
          } else if (column === "Received Amount") {
            result[column] = transformedEntry?.Received_Amount;
          } else if (column === "Sale Load") {
            result[column] = transformedEntry?.Sale_Load;
          } else if (column === "Net Sale amount") {
            result[column] = transformedEntry?.Net_Sale_amount;
          } else if (column === "Units Sold") {
            result[column] = transformedEntry?.Units_Sold;
          } else if (column === "Current Holding") {
            result[column] = transformedEntry?.Current_Holding;
          } else if (column === "Oustanding Units") {
            result[column] = transformedEntry?.Oustanding_Units;
          } else if (column === "Created By") {
            result[column] = transformedEntry?.Created_By;
          }
          // nccpl report
          else if (column === "Date") {
            result[column] =
              distName === "nccpl"
                ? moment(transformedEntry?.Date)?.format("D/M/YYYY")
                : transformedEntry?.Date;
          } else if (column === "Transaction ID Name") {
            result[column] = transformedEntry?.Transaction_ID_Name;
          } else if (column === "S No") {
            result[column] = transformedEntry?.S_No;
          } else if (column === "Settlement") {
            result[column] =
              distName === "nccpl"
                ? moment(transformedEntry?.Settlement)?.format("D/M/YYYY")
                : transformedEntry?.Settlement;
          } else if (column === "IN/OUT") {
            result[column] = transformedEntry?.INOUT;
          } else if (column === "Inventory Date") {
            result[column] =
              distName === "nccpl"
                ? moment(transformedEntry?.Inventory_Date)?.format("D/M/YYYY")
                : transformedEntry?.Inventory_Date;
          } else if (column === "PRU/RDU") {
            result[column] = transformedEntry?.PRURDU;
          } else if (column === "Fund ID") {
            result[column] = transformedEntry?.Fund_ID;
          } else if (column === "FUND CODE") {
            result[column] = transformedEntry?.FUND_CODE;
          } else if (column === "UIN/NTN") {
            result[column] = transformedEntry?.UINNTN;
          } else if (column === "Account No") {
            result[column] = transformedEntry?.Account_No;
          } else if (column === "Units IN/OUT") {
            result[column] = transformedEntry?.Units_INOUT;
          } else if (column === "NAV Price Price") {
            result[column] = transformedEntry?.NAV_Price_Price;
          } else if (column === "Counter Transaction") {
            result[column] = transformedEntry?.Counter_Transaction;
          } else if (column === "NCC REF") {
            result[column] = transformedEntry?.NCC_REF;
          } else if (column === "GAIN/LOSS") {
            result[column] = transformedEntry?.GAINLOSS;
          } else if (column === "CGT AMOUNT") {
            result[column] = transformedEntry?.CGT_AMOUNT;
          } else if (column === "UNIT Balance Before") {
            result[column] = transformedEntry?.UNIT_Balance_Before;
          } else if (column === "UNIT Balance After") {
            result[column] = transformedEntry?.UNIT_Balance_After;
          } else if (column === "Dividend Gain Info") {
            result[column] = transformedEntry?.Dividend_Gain_Info;
          } else if (column === "Semi_Colon") {
            result[column] = ";";
          }
        });

        return result;
      });

    let formattedContent: any = "";

    if (distName !== "nccpl") {
      formattedContent = `${
        selectedValues?.heading ? selectedValues?.heading : ""
      },,,\n`;
      formattedContent += `${
        selectedValues?.sub_heading ? selectedValues?.sub_heading : ""
      },,,\n`;
      formattedContent += `"Fund:","${resFund}",`;
      formattedContent += `"Transaction Type:","${
        distName === "nccpl" ? "NCCPL" : CapTxnType(txn_type)
      }",,\n`;
      formattedContent += `"From Date:","${moment(from_date).format(
        "DD-MM-YYYY",
      )}",`;
      formattedContent += `"To Date:","${
        moment(to_date).format("DD-MM-YYYY") === "Invalid date"
          ? to_date
          : moment(to_date).format("DD-MM-YYYY")
      }",,\n`;
      formattedContent += `"Status:","${status}",`;
      formattedContent += `"Report Date:","${moment(date).format(
        "DD-MM-YYYY",
      )}",,\n`;
    }

    if (distName === "nccpl") {
      selectedValues.columns = [...selectedValues.columns, "Semi_Colon"];
      exportToTxtNCCPL(
        formattedContent,
        // selectedValues,
        [],
        ArrayData,
        "NCCPL",
      );
    } else {
      exportToTxt(
        formattedContent,
        selectedValues,
        ArrayData,
        "Transaction Report",
      );
    }
  };

  const handleShowMore = () => {
    setItemsToShow((prev) => prev + itemsPerPage);
  };

  const handleGeneratePdf = () => {
    const element = contentRef.current;
    let fileName = "Transaction-Report.pdf";
    const options = {
      filename: fileName,
      margin: [10, 5, 10, 5],
      image: { type: "jpeg", quality: 1.0 },
      html2canvas: {
        scale: 2, // High resolution capture (prevents logo pixelation)
        useCORS: true,
        allowTaint: true,
        logging: false,
      },
      jsPDF: {
        unit: "mm",
        format: paperSizeVal || "A4",
        orientation: layoutVal === "Landscape" ? "landscape" : "portrait",
      },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };
    html2pdf().from(element).set(options).save();
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              <ToastContainer limit={1} />
              <div className="">
                <div className="card">
                  <div className="card-header">
                    <h4 className="card-title">
                      {distName === "nccpl"
                        ? "CGT Report for NCCPL"
                        : "Transaction Report"}
                    </h4>
                  </div>
                  <div className="card-body">
                    <Row>
                      <Col md="4">
                        <div className="form-group">
                          <label>Select Fund</label>
                          <Select
                            value={selectedFund}
                            label={"Select Fund"}
                            onChange={(e) => {
                              setFund(e?.label);
                              setFields({
                                ...fields,
                                fund_code: e?.value,
                              });
                              setReportTxn([]);
                              setItemsPerPage(10);
                              setItemsToShow(10);
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={renderFundsDropDown()}
                            styles={customStyles}
                          />
                          {/* <select
                            className="form-control"
                            onChange={(e) => {
                              setFund(
                                e.nativeEvent.target == null
                                  ? ""
                                  : e.nativeEvent.target[e.target.selectedIndex]
                                    .text
                              );
                              let temp = e.nativeEvent.target == null
                                ? ""
                                : e.nativeEvent.target[e.target.selectedIndex]
                                  .text
                              setFields({
                                ...fields,
                                fund_code: e.target.value,
                              });
                            }}
                          >
                            <option value="" defaultChecked hidden>
                              Select Fund
                            </option>
                            {renderFundsDropDown()}
                          </select> */}
                        </div>
                      </Col>

                      {!distName && (
                        <>
                          <Col md="4">
                            <div className="form-group">
                              <label>Report Type</label>
                              <Select
                                value={selectedTransactionType}
                                label={"Select type"}
                                onChange={(e) => {
                                  setFields({
                                    ...fields,
                                    txn_type: e?.value,
                                  });
                                  let fieldData = getReuiredFieldForDropDown(
                                    e?.value,
                                  );
                                  setHeaderCoumns(fieldData);
                                  setColumnArr(fieldData);
                                  setSelectedValues({
                                    ...selectedValues,
                                    columns: fieldData?.map(
                                      (item) => item?.label,
                                    ),
                                  });
                                  setReportTxn([]);
                                  setItemsPerPage(10);
                                  setItemsToShow(10);
                                }}
                                menuPortalTarget={document.body}
                                menuShouldBlockScroll={true}
                                isClearable={true}
                                isSearchable={true}
                                name="color"
                                options={renderTxnTypeDropdown()}
                                styles={customStyles}
                              />
                            </div>
                          </Col>
                          {/* {distName && distName === "nccpl" &&
                        <Col md="4">
                          <div className="form-group">
                            <label>Report Type</label>
                            <MultiSelect
                              options={NCCPLArr}
                              value={NCCPLArr?.filter((option) =>
                                txnTypesMulti?.some((selected) => selected.value === option.value)
                              )}
                              onChange={(selectedOptions) => {
                                setFields({
                                  ...fields,
                                  txn_type: selectedOptions.map((opt) => opt.value),
                                });
                                setTxnTypesMulti(selectedOptions);
                                let fieldData;
                                if (selectedOptions?.length > 1) {
                                  fieldData = getReuiredFieldForDropDown(
                                    "nccpl"
                                  );
                                  setFields({
                                    ...fields,
                                    txn_type: `saleofunit,redemptionofunits,conversionout,conversionin`,
                                  });
                                }
                                else {
                                  fieldData = getReuiredFieldForDropDown(
                                    selectedOptions[0]?.value
                                  )
                                  setFields({
                                    ...fields,
                                    txn_type: selectedOptions[0]?.value,
                                  });
                                }

                                setHeaderCoumns(fieldData);
                                setColumnArr(fieldData);
                                setSelectedValues({
                                  ...selectedValues,
                                  columns: fieldData?.map((item) => item?.label),
                                });
                                setReportTxn([]);
                                setItemsPerPage(10);
                                setItemsToShow(10);
                              }}
                              labelledBy={"Select Txn Types"}
                              className={`multi-select reportTxn-multi-select-${theme}`}
                              overrideStrings={{
                                selectAll: "Select all Txn Type",
                                selectSomeItems: "Select Txn Type",
                              }}
                            />
                          </div>
                        </Col>
                      } */}
                          <Col md="4">
                            <div className="form-group  ">
                              <label>Transaction Status</label>
                              <Select
                                value={selectedTransactionStatus}
                                label={"Select type"}
                                onChange={(e) => {
                                  setFields({
                                    ...fields,
                                    status: e?.value,
                                  });
                                  setReportTxn([]);
                                  setItemsPerPage(10);
                                  setItemsToShow(10);
                                }}
                                menuPortalTarget={document.body}
                                menuShouldBlockScroll={true}
                                isClearable={true}
                                isSearchable={true}
                                name="color"
                                options={transaction_Status}
                                styles={customStyles}
                              />
                            </div>
                          </Col>
                        </>
                      )}
                      <Col md="4">
                        <div className="form-group  ">
                          <label>Settlement Date From</label>
                          <input
                            style={{
                              colorScheme: theme == "light" ? "light" : "dark",
                            }}
                            type="date"
                            value={fields["from_date"]}
                            className="form-control py-1"
                            onChange={(e) => {
                              setFields({
                                ...fields,
                                from_date: e.target.value,
                              });
                              setReportTxn([]);
                              setItemsPerPage(10);
                              setItemsToShow(10);
                            }}
                          />
                        </div>
                      </Col>
                      <Col md="4">
                        <div className="form-group  ">
                          <label>Settlement Date To</label>
                          <input
                            type="date"
                            style={{
                              colorScheme: theme == "light" ? "light" : "dark",
                            }}
                            value={fields["to_date"]}
                            className="form-control py-1"
                            onChange={(e) => {
                              setFields({
                                ...fields,
                                to_date: e.target.value,
                              });
                              setReportTxn([]);
                              setItemsPerPage(10);
                              setItemsToShow(10);
                            }}
                          />
                        </div>
                      </Col>
                    </Row>
                    <div className=" ">
                      {/* here Search Button */}
                      <button
                        className="btn btn-primary mt-3"
                        onClick={() => {
                          searchData();
                        }}
                        disabled={Boolean(loading)}
                      >
                        {loading ? (
                          <>
                            <span
                              className="spinner-border login-txt spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span className="login-txt"> Loading...</span>
                          </>
                        ) : (
                          <span>Search</span>
                        )}
                      </button>
                    </div>
                    {/* End */}
                  </div>
                </div>
                {/* here Search results for report Data */}
                <div className="card mt-3">
                  <div className="card-body">
                    {/* ------------------ Report template starts here ---------- */}
                    {reportTxn.length > 0 && (
                      <Row>
                        <ReportTemplates
                          ColumnArr={ColumnArr}
                          selectedValues={selectedValues}
                          setSelectedValues={setSelectedValues}
                          pdfExportComponent={pdfExportComponent}
                          setFontSizeVal={setFontSizeVal}
                          fontSizeVal={fontSizeVal}
                          setPaperSizeVal={setPaperSizeVal}
                          paperSizeVal={paperSizeVal}
                          setLayoutVal={setLayoutVal}
                          layoutVal={layoutVal}
                          setScalePDF={setScalePDF}
                          scalePDF={scalePDF}
                          setMarginPDF={setMarginPDF}
                          marginPDF={marginPDF}
                          setScreenSizePerPdf={setScreenSizePerPdf}
                          screenSizePerPdf={screenSizePerPdf}
                          setDimensionOfPages={setDimensionOfPages}
                          contentRef={contentRef}
                          fileName={
                            distName === "nccpl"
                              ? `nccpl.pdf`
                              : "Transaction.pdf"
                          }
                          printExcel={handleDownloadSampleFile}
                          printTXT={handleTXT}
                          printpdf={handleGeneratePdf}
                        />
                      </Row>
                    )}
                    {/* ------------------ Report template ends here ---------- */}
                    <div
                      id="printDiv"
                      className="p-2"
                      style={{
                        color: "black",
                        minWidth: "200px",
                        overflowX: "auto",
                        width: "auto",
                      }}
                    >
                      <div
                        style={{
                          width: `${
                            dimensionOfPages?.find(
                              (item) => item?.key == paperSizeVal,
                            )?.dimensions[layoutVal == "Portrait" ? 0 : 1]
                          }`,
                          height: "auto",
                          margin: "0 auto",
                          backgroundColor: "white",
                        }}
                        className="border"
                      >
                        <PDFExport
                          paperSize={paperSizeVal || "A4"}
                          margin={{
                            top: "1.5cm",
                            left: "1.5cm",
                            right: "1.5cm",
                            bottom: "6cm",
                          }}
                          scale={scalePDF}
                          repeatHeaders={true}
                          landscape={layoutVal === "Landscape" ? true : false}
                          fileName={"Transaction-Report-" + date + ".pdf"}
                          ref={pdfExportComponent}
                        >
                          <div
                            style={{
                              margin: "0.25in",
                            }}
                            ref={contentRef}
                          >
                            {reportTxn?.length > 0 ? (
                              <>
                                <ReportHeader
                                  title={
                                    distName === "nccpl"
                                      ? "CGT Report for NCCPL"
                                      : `${CapTxnType(txn_type)} Report`
                                  }
                                />

                                {distName !== "nccpl" ? (
                                  <DividendCard
                                    cardData={[
                                      { title: "Fund", value: resFund },
                                      {
                                        title: "Transaction Type",
                                        value:
                                          distName === "nccpl"
                                            ? "NCCPL"
                                            : CapTxnType(txn_type),
                                      },
                                      {
                                        title: "From Date",
                                        value:
                                          moment(from_date).format(
                                            "DD-MM-YYYY",
                                          ),
                                      },
                                      {
                                        title: "To Date",
                                        value:
                                          moment(to_date).format(
                                            "DD-MM-YYYY",
                                          ) === "Invalid date"
                                            ? to_date
                                            : moment(to_date).format(
                                                "DD-MM-YYYY",
                                              ),
                                      },
                                      { title: "Status", value: status },
                                      {
                                        title: "Report Date",
                                        value:
                                          moment(date).format("DD-MM-YYYY"),
                                      },
                                    ]}
                                    reportName={"TR"}
                                    report={true}
                                  />
                                ) : null}

                                {selectedValues?.columns?.length > 0 ? (
                                  fields["txn_type"] === "transferofunits" ? (
                                    <TransactionTransferTable
                                      reportTxn={reportTxn}
                                      itemsToShow={itemsToShow}
                                    />
                                  ) : (
                                    <TransactionDefaultTable
                                      dropdownList={dropdownList}
                                      selectedValues={selectedValues}
                                      reportTxn={reportTxn}
                                      itemsToShow={itemsToShow}
                                      renderDropdownValues={
                                        renderDropdownValues
                                      }
                                      distName={distName}
                                      totals={{
                                        totalNetAmount,
                                        totalGrossAmount,
                                        totalSaleLoad,
                                        totalCGT,
                                        totalRedemptionLoad,
                                        totalUnits,
                                        totalCurrentHolding,
                                        totalZakatAmount,
                                        totalWHT_II,
                                        totalWHT_SST,
                                        totalTax_SST,
                                        totalTotalAmount,
                                        totalTotalTaxItBonusAmount,
                                        totalTotatNetBonusVolume,
                                        totalRightShareGrossVolume,
                                        totalTaxITRightShareAmount,
                                        totalNetRightShareVolume,
                                      }}
                                    />
                                  )
                                ) : (
                                  <div className="text-center my-5">
                                    <b>No column selected</b>
                                  </div>
                                )}
                              </>
                            ) : (
                              <div className="table-empty">
                                <BsTable className="icon" />
                                <p className="text-center text-primary empty-text">
                                  No record found
                                </p>
                              </div>
                            )}
                          </div>
                        </PDFExport>
                      </div>
                    </div>

                    <div className="row align-items-center">
                      <div className="col-md-4">
                        {reportTxn?.length >= 10 &&
                          selectedValues?.columns?.length > 0 && (
                            <UncontrolledDropdown
                              className="me-2 mt-2"
                              direction="down"
                            >
                              <DropdownToggle
                                id="TotalRecord_dropdown"
                                style={{
                                  background: "none",
                                  padding: "0px",
                                  margin: "0px",
                                }}
                                className="border"
                              >
                                <div
                                  id="report_dropdown"
                                  style={{
                                    borderRadius: "4px",
                                    padding: "5px 15px",
                                    color: theme == "light" ? "black" : "white",
                                  }}
                                >
                                  Per page : {itemsPerPage}
                                </div>
                              </DropdownToggle>
                              <DropdownMenu
                                style={{
                                  maxHeight: "300px",
                                  overflow: "auto",
                                  backgroundColor:
                                    theme == "dark" ? "rgb(30, 30, 47)" : "",
                                }}
                              >
                                <DropdownItem
                                  className={
                                    itemsPerPage == 10
                                      ? "bg-info text-white"
                                      : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage(10);
                                    setItemsToShow(10);
                                  }}
                                >
                                  10
                                </DropdownItem>
                                <DropdownItem
                                  className={
                                    itemsPerPage == 25
                                      ? "bg-info text-white"
                                      : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage(25);
                                    setItemsToShow(25);
                                  }}
                                >
                                  25
                                </DropdownItem>
                                <DropdownItem
                                  className={
                                    itemsPerPage == 50
                                      ? "bg-info text-white"
                                      : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage(50);
                                    setItemsToShow(50);
                                  }}
                                >
                                  50
                                </DropdownItem>
                                <DropdownItem
                                  className={
                                    itemsPerPage == "All"
                                      ? "bg-info text-white"
                                      : ""
                                  }
                                  onClick={() => {
                                    setItemsPerPage("All");
                                    setItemsToShow(reportTxn?.length);
                                  }}
                                >
                                  All
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          )}
                      </div>
                      <div className="col-md-4">
                        {itemsToShow < reportTxn?.length &&
                          selectedValues?.columns?.length > 0 && (
                            <div className="d-flex justify-content-center my-2">
                              <button
                                className="btn btn-primary mt-3"
                                onClick={handleShowMore}
                              >
                                Show More
                              </button>
                            </div>
                          )}
                      </div>
                      <div className="col-md-4">
                        {reportTxn?.length > 0 &&
                          selectedValues?.columns?.length > 0 && (
                            <div className="d-flex align-items-center justify-content-end">
                              <div
                                id="TotalRecord_dropdown"
                                className="border dropdown-toggle btn btn-secondary btn-sm ml-1"
                                style={{
                                  borderRadius: "4px",
                                  color: theme == "light" ? "black" : "white",
                                  marginTop: "13px",
                                }}
                              >
                                Total record :{" "}
                                {selectedValues?.columns?.length > 0
                                  ? reportTxn?.length
                                  : 0}
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default TransactionReportScreen;
